import { render } from "./AvailableBrands.vue?vue&type=template&id=b2d5b1f2"
import script from "./AvailableBrands.vue?vue&type=script&lang=js"
export * from "./AvailableBrands.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__